import React from 'react';
import PropTypes from 'prop-types';

/**
 * A minimal top-level container that organizes multiple <ViewportPane>
 * children in a grid. Typically driven by a layout config.
 */
function ViewportGrid({ numRows, numCols, layoutType, children }) {
  return (
    <div
      data-cy="viewport-grid"
      style={{
        position: 'relative',
        height: '100%',
        width: '100%',
      }}
    >
      {/* Inyectamos el estilo para forzar el logo con !important */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .overlay-image-wrapper {
              position: absolute !important;
              bottom: 55px !important;
              right: 10px !important;
              width: 90px !important;
              z-index: 1000 !important;
              pointer-events: none !important;
              display: block !important;
            }

            .overlay-image-wrapper img {
              width: 100% !important;
              height: 100% !important;
              object-fit: contain !important;
              opacity: 1 !important;
              display: block !important;
              border-radius: 20px !important;
            }
          `,
        }}
      />

      {/* Aquí inyectamos el logo */}
      <div className="overlay-image-wrapper">
        <img
          src="/assets/logo.png"
          alt="Overlay"
        />
      </div>

      {children}
    </div>
  );
}

ViewportGrid.propTypes = {
  numRows: PropTypes.number.isRequired,
  numCols: PropTypes.number.isRequired,
  layoutType: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export { ViewportGrid };
